export default {
  notificacoes: [],
  qtdNotRead: 0,
  loading: false,
}
